import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api';

export const useAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Track page view
        const trackPageView = async () => {
            try {
                await api.post('/analytics/page-view/', {
                    page_path: location.pathname,
                    timestamp: new Date().toISOString()
                });
            } catch (error) {
                console.error('Analytics tracking failed:', error);
            }
        };

        trackPageView();
    }, [location.pathname]);

    const trackFeatureUsage = async (featureName, featureData = {}) => {
        try {
            await api.post('/analytics/feature-usage/', {
                feature_name: featureName,
                feature_data: featureData,
                timestamp: new Date().toISOString()
            });
        } catch (error) {
            console.error('Feature tracking failed:', error);
        }
    };

    const trackSearch = async (searchType, searchTerm, filters = {}, resultsCount = 0) => {
        try {
            await api.post('/analytics/search/', {
                search_type: searchType,
                search_term: searchTerm,
                filters_used: filters,
                results_count: resultsCount,
                timestamp: new Date().toISOString()
            });
        } catch (error) {
            console.error('Search tracking failed:', error);
        }
    };

    return {
        trackFeatureUsage,
        trackSearch
    };
};